import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';

import { TopMoversRestService } from '../../../services/top-movers/top-movers-rest.service';
import { SymbolType } from '../../../domain/symbol.domain';
import { TopMoversSortType, TopMover, TopMovers } from '../../../domain/top-movers/top-movers.domain';

import { EventsData, EventType } from '../market-info/market-info.domain';
import { MarketInfoEventsRestService } from '../market-info/market-info-events-rest-service';

@Injectable()
export class TopSectionService {
  constructor(private topMoversRestService: TopMoversRestService,
              private marketInfoEventsRestService: MarketInfoEventsRestService) {
  }

  getTopMoversData(sortType?: TopMoversSortType): Observable<TopMovers> {
    return this.topMoversRestService.getTopMovers(sortType);
  }

  getTopSectionData(sortType?: TopMoversSortType): Observable<TopMovers> {
    return this.getTopMoversData(sortType)
      .pipe(
        mergeMap((response: TopMovers): Observable<TopMovers> => forkJoin([
          this.addRatings(response.topMovers, sortType).pipe(catchError((): Observable<void> => of(undefined))),
          this.addEventsAndNews(response.topMovers).pipe(catchError((): Observable<void> => of(undefined)))
        ]).pipe(map((): TopMovers => response)))
      );
  }

  showMarketIcon(topMover: TopMover): boolean {
    return topMover.holding === undefined ||
        topMover.holding.security === undefined ||
        topMover.holding.security.type !== SymbolType.MUTUALFUND;
  }

  private addEventsAndNews(topMovers: Array<TopMover>): Observable<void> {
    return this.marketInfoEventsRestService.getEvents([EventType.RATING_CHANGES, EventType.DIVIDENDS, EventType.EARNINGS])
      .pipe(
        mergeMap((marketEvents: EventsData): Observable<void> => this.topMoversRestService
          .addEventsAndNewsToTopMovers(topMovers, marketEvents))
      );
  }

  private addRatings(topMovers: Array<TopMover>, sortType: TopMoversSortType): Observable<void> {
    if (sortType !== undefined) {
      return of(undefined);
    }
    return this.topMoversRestService.addRatings(topMovers);
  }
}

